import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { HelpCircle, Info } from "react-feather";
import { TaxYearlyReport } from "../../../../../models";
import { thousandize } from "../../../../../util/formatting";
import { Lightbox } from "../../../../shared/components/Lightbox/Lightbox";
import style from "./TaxYearlyReportListBody.module.scss";
export const TaxYearlyReportListBody: React.FC<{
  report: TaxYearlyReport;
}> = t0 => {
  const $ = _c(17);
  const {
    report
  } = t0;
  const [nonDeductibleInfoOpen, setNonDeductibleInfoOpen] = useState(false);
  if (report.sumDonations == 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <thead><tr><th colSpan={2}>Donasjoner som kvalifiserer til skattefradrag</th></tr></thead>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== report.units) {
    t2 = report.units.reduce(_temp, []).map(_temp2);
    $[1] = report.units;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <td>Totalt</td>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== report.sumDonations) {
    t4 = thousandize(report.sumDonations);
    $[4] = report.sumDonations;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <tr>{t3}<td>{t4} kr</td></tr>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <table className={style.summaryTable} data-cy="yearly-tax-report-summary-table">{t1}<tbody>{t2}{t5}</tbody></table>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== nonDeductibleInfoOpen || $[12] !== report.sumNonDeductibleDonationsByType) {
    t7 = report.sumNonDeductibleDonationsByType.reduce(_temp3, 0) > 0 && <><Lightbox open={nonDeductibleInfoOpen} onConfirm={() => setNonDeductibleInfoOpen(false)}><div className={style.nonDeductibleInfo}><p><strong>Cryptodonasjoner</strong> kvalifiserer ikke til skattefradrag.</p><p><strong>Donasjoner uten skatteenhet</strong> kvalifiserer ikke til skattefradrag. Om du ikke har noen registrerte skatteenheter kan du registrere en til venstre i menyen under "skatt" og vi vil knytte donasjonene for i år til denne enheten. Har du allerede en eller flere enheter, ta kontakt på{" "}<a href="mailto:donasjon@gieffektivt.no">donasjon@gieffektivt.no</a> slik at vi kan knytte rett donasjon til rett skatteenhet.</p><p><strong>Donasjoner gitt til Stiftelsen Effekt</strong> direkte kvalifiserer ikke til skattefradrag, da stiftelsen ikke er skattefradragsgodkjent.</p></div></Lightbox><table className={style.nonDeductibleDonationsTable} data-cy="yearly-tax-report-non-deductable-table"><thead><tr><th colSpan={2}><div className={style.cellContent}>Donasjoner som ikke er fradragsgodkjente{" "}<HelpCircle size="1rem" onClick={() => setNonDeductibleInfoOpen(true)} data-cy="tax-report-tooltip-icon" /></div></th></tr></thead><tbody>{report.sumNonDeductibleDonationsByType.map(_temp4)}</tbody></table><div className={style.mobileOrgInfo}><strong>Effektiv Altruisme Norge</strong><span> Org.nr 919 809 140</span></div></>;
    $[11] = nonDeductibleInfoOpen;
    $[12] = report.sumNonDeductibleDonationsByType;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
function _temp(acc, unit) {
  unit.channels.forEach(channel => {
    const channelInAcc = acc.find(c => c.channel === channel.channel);
    if (channelInAcc) {
      channelInAcc.sumDonations = channelInAcc.sumDonations + channel.sumDonations;
    } else {
      acc.push({
        ...channel
      });
    }
  });
  return acc;
}
function _temp2(channel_0) {
  return <tr key={channel_0.channel}><td>Gitt gjennom {channel_0.channel}</td><td>{thousandize(channel_0.sumDonations)} kr</td></tr>;
}
function _temp3(acc_0, n) {
  return acc_0 + n.sumNonDeductibleDonations;
}
function _temp4(nondeductible) {
  return <tr key={nondeductible.type}><td>{nondeductible.type}</td><td>{thousandize(nondeductible.sumNonDeductibleDonations)} kr</td></tr>;
}